import React, { useState, useContext } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionPanel,
  AccordionIcon,
  Box,
  AccordionButton,
  Flex,
  Text,
} from "@chakra-ui/react";
import { Link, useLocation } from "react-router-dom";
import { Context } from "../store";
import { BiCube } from "react-icons/bi";
import { RxLapTimer } from "react-icons/rx";
import { IoMdChatbubbles } from "react-icons/io";
import { TbTruckReturn } from "react-icons/tb";
import { BsFileEarmarkCheckFill } from "react-icons/bs";
import { TbTruckDelivery } from "react-icons/tb";
import { BsFillPersonCheckFill } from "react-icons/bs";
import { BsFillPeopleFill } from "react-icons/bs";
import { IoIosNotifications } from "react-icons/io";
import { IoMdSettings } from "react-icons/io";

const Sidebar = ({ isBase, onClose, data }) => {
  const [activeIndex, setActiveIndex] = useState(parseInt(sessionStorage.getItem(`myVar`)))
  const loc = useLocation();

  const { userData } = useContext(Context)
  const user = userData
  // const UserGroupPermission = user.UserGroupPermission
  // const user = JSON.parse(localStorage.getItem('user'))

  const UserGroupPermission = user?.UserGroupPermission
  const userGroupMember = user?.userGroupMember
  // add borderLeft when on click & remove accordion dynamically created div padding
  const handleAccordionClick = (index) => {
    sessionStorage.setItem(`myVar`, index);
    setActiveIndex(parseInt(sessionStorage.getItem(`myVar`)))
  };

  // Main data of side bar items
  let sideBarData = []

 
  if (Object.keys(userData).length > 0) {
    if (userGroupMember.includes('ADMIN')) {
      sideBarData = data
    }
   else {
    sideBarData = data.filter((x) => UserGroupPermission.includes(x.id))
   }
  }



  const onSelectItem = {
    fontWeight: '700',
    bgColor: 'rgba(67, 138, 254, 0.1)'
  }



  return (
    <Box
      w={{ base: `${isBase ? '100%' : '20%'}`, md: `${isBase ? '100%' : '20%'}`, lg: '20%', xl: '20%', '2xl': '20%' }}
      display={{ base: `${isBase ? 'block' : 'none'}`, md: `${isBase ? 'block' : 'none'}`, lg: 'block', xl: 'block', '2xl': 'block' }}
      bgColor={'white'}
    >

      <Accordion allowToggle defaultIndex={activeIndex} onChange={(e) => handleAccordionClick(e)} mt={{ base: 0, md: 0, lg: 2, xl: 2, '2xl': 2 }} maxHeight={`${window.innerHeight - 78}px`} overflowY={'scroll'}
        css={{
          '&::-webkit-scrollbar': { width: '6px' }, '&::-webkit-scrollbar-track': { backgroundColor: 'white' },
          '&::-webkit-scrollbar-thumb': { boxShadow: 'inset 0 0 6px #3182ce', borderRadius: '6px' }
        }}
        position={'sticky'}
        top={'80px'}
      >
        {sideBarData.map((x, i) => {
          return (
            Object.keys(Object.values(x)[0][0]).length > 1 ?
              <AccordionItem border={'unset'} key={i}>
                <AccordionButton borderLeft={activeIndex === i ? "6px solid rgba(67, 138, 254, 1)" : "none"} pl={activeIndex === i ? '10px' : '16px'} bgColor={activeIndex === i ? "rgba(67, 138, 254, 0.1)" : ""} _hover={{ bgColor: "rgba(67, 138, 254, 0.1)" }}>
                  <Flex as="span" flex="1" textAlign="left" color={activeIndex === i ? "rgba(67, 138, 254, 1)" : "rgba(0, 0, 0, 1)"} alignItems={'center'} >
                    <Text as={'span'} dangerouslySetInnerHTML={{ __html: x.icon }} />
                    <Text fontSize={'18px'} ml={2}>{Object.keys(x)[0]}</Text>
                  </Flex>
                  <AccordionIcon />
                </AccordionButton>
                <AccordionPanel pt={2} pr={0} pl={0} pb={4}>
                  {Object.values(x)[0].map((y, index) => {

                    return (
                      <Link to={y.url} onClick={onClose} key={index}>
                        <Box py={1} px={'22px'} textAlign="left" sx={(loc.pathname === y.url) ? onSelectItem : ''}>
                          <Text fontSize={'16px'}>{y.title}</Text>
                        </Box>
                      </Link>
                    )
                  })}
                </AccordionPanel>
              </AccordionItem>

              :

              <AccordionItem border={'unset'} key={i}>
                <Link to={Object.values(x)[0][0].url}>
                  <AccordionButton color={activeIndex === i ? "rgba(67, 138, 254, 1)" : "rgba(0, 0, 0, 1)"} borderLeft={activeIndex === i ? "6px solid rgba(67, 138, 254, 1)" : "none"} pl={activeIndex === i ? '10px' : '16px'} bgColor={activeIndex === i ? "rgba(67, 138, 254, 0.1)" : ""} _hover={{ bgColor: "rgba(67, 138, 254, 0.1)" }}>
                    <Flex as="span" flex="1" textAlign="left" onClick={onClose}>
                      <Text as={'span'} dangerouslySetInnerHTML={{ __html: Object.values(x)[1] }} />
                      <Text fontSize={'18px'} ml={2}>{Object.keys(x)[0]}</Text>
                    </Flex>
                  </AccordionButton>
                </Link>
              </AccordionItem>
          )
        })}

      </Accordion>
    </Box>
    // </Box>
  );
};

export default Sidebar;
